import { render, staticRenderFns } from "./PassErrorsBlock.vue?vue&type=template&id=210089a3&"
import script from "./PassErrorsBlock.vue?vue&type=script&lang=js&"
export * from "./PassErrorsBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports